// extracted by mini-css-extract-plugin
export var box = "SectionContent-module--box--34926";
export var box_md = "SectionContent-module--box_md--51fd5";
export var box_xmd = "SectionContent-module--box_xmd--66172";
export var box_flex = "SectionContent-module--box_flex--e57bd";
export var box_lg = "SectionContent-module--box_lg--6ad0d";
export var box_sm = "SectionContent-module--box_sm--8099e";
export var box_outer = "SectionContent-module--box_outer--43530";
export var box_whiteBg = "SectionContent-module--box_white-bg--ab464";
export var box_noMarginBottom = "SectionContent-module--box_no-margin-bottom--b0632";
export var box_noPadding = "SectionContent-module--box_no-padding--b8fed";
export var box_outerGray = "SectionContent-module--box_outer-gray--804b0";
export var box_dark = "SectionContent-module--box_dark--aa380";
export var box_zIndex = "SectionContent-module--box_z-index--e1bc3";
export var box_zIndex6 = "SectionContent-module--box_z-index-6--41e96";
export var box_eventsWithLine = "SectionContent-module--box_events-with-line--0f4e8";
export var box_featuresAo = "SectionContent-module--box_features-ao--5d0d7";
export var box_verticalPaddings = "SectionContent-module--box_vertical-paddings--b4fd4";
export var clearP = "SectionContent-module--clearP--5b017";
export var clearP_vc = "SectionContent-module--clearP_vc--250cc";
export var section = "SectionContent-module--section--b5c2a";
export var imgWrapper = "SectionContent-module--imgWrapper--67c54";
export var infoWrapper = "SectionContent-module--infoWrapper--0ad69";
export var title = "SectionContent-module--title--f3b3b";
export var subtitle = "SectionContent-module--subtitle--96aeb";
export var list = "SectionContent-module--list--84441";
export var notice = "SectionContent-module--notice--63e4a";
export var linkText = "SectionContent-module--linkText--842b8";
export var button = "SectionContent-module--button--a351b";
export var fadeInAnimation = "SectionContent-module--fadeInAnimation--e138b";
export var placeHolderShimmer = "SectionContent-module--placeHolderShimmer--d27f2";